import { useSnackbar } from 'notistack';
import { useState } from 'react';
import {
  AddProjectInitialValues,
  AddProjectInitialValidation,
  AddProjectTrueValidation,
} from '../../initial-values';
import { AddProjectDto } from '../../types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { isValidationValidated } from '../../utils/helper';
import X from '../../assets/icons/new_icon/x.svg';
import calendarIcon from '../../assets/icons/new_icon/calendar.svg';
import { addProject } from '../../api/admin';
import SelectSubAccountDropdown from '../global-components/selectSubAccountDropdown';
import SelectOwnerDropdown from '../global-components/SelectOwnerDropdown';

interface Props {
  onClose: any;
  onSuccess: any;
  editData?: any;
}
const AddProjectModal = ({ onClose, onSuccess, editData }: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(false);
  const [formData, setFormData] = useState<AddProjectDto>(
    AddProjectInitialValues
  );
  const [formValidations, setFormValidations] = useState(
    AddProjectInitialValidation
  );

  function handleAction() {
    setValidating(true);
    if (
      formData.start_date &&
      formData.end_date &&
      new Date(formData.start_date) > new Date(formData.end_date)
    ) {
      enqueueSnackbar('Start Date cannot be greater than End Date.', {
        variant: 'error',
      });
      return;
    }
    if (isValidationValidated(formValidations)) {
      setLoading(true);
      addProject(formData)
        .then((response) => {
          if (!response.data.is_error) {
            enqueueSnackbar('Project has been added.', {
              variant: 'success',
            });
            onSuccess();
            setLoading(false);
          }
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  }

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <div
      className='modal'
      id='project_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      aria-labelledby='project_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div className='modal-dialog modal-md'>
        <div className='modal-content'>
          <div className='modal-header d-flex w-100 justify-content-between px-3 py-2'>
            <h3 className='newubbemodalheading  mb-0'>Project Details</h3>
            <img
              src={X}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <div className='modal-body'>
            <div className='mb-3'>
              <label htmlFor='code' className=' globalInputLabel'>
                Code
              </label>
              <span className='text-danger'>*</span>

              <input
                type='text'
                className={`form-control  ubbe-input  ${
                  validating && formData.code !== ''
                    ? ''
                    : validating && formData.code === ''
                    ? 'is-invalid'
                    : ''
                } ${formData.code ? 'highlighted-border' : ''}`}
                id='code'
                placeholder='Ex: WR2025'
                autoComplete='new-password'
                value={formData.code}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    code: e.target.value,
                  });
                  setFormValidations({
                    ...formValidations,
                    code: e.target.value !== '',
                  });
                }}
              />
              {validating && formData.code === '' && (
                <div className='error_text'>
                  {'Please provide a valid code.'}
                </div>
              )}
            </div>
            <div className='mb-3'>
              <label htmlFor='name' className=' globalInputLabel'>
                Name <span className='text-danger'>*</span>
              </label>
              <input
                type='text'
                className={`form-control  ubbe-input  ${
                  validating && formData.name !== ''
                    ? ''
                    : validating && formData.name === ''
                    ? 'is-invalid'
                    : ''
                } ${formData.name ? 'highlighted-border' : ''}`}
                id='name'
                placeholder='Ex: Winterroad 2025'
                autoComplete='new-password'
                value={formData.name}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    name: e.target.value,
                  });
                  setFormValidations({
                    ...formValidations,
                    name: e.target.value !== '',
                  });
                }}
              />
              {validating && formData.name === '' && (
                <div className='error_text'>
                  {'Please provide a valid name.'}
                </div>
              )}
            </div>
            <div className='mb-3'>
              <label htmlFor='description' className=' globalInputLabel'>
                Description <span className='text-danger'>*</span>
              </label>
              <input
                type='text'
                className={`form-control  ubbe-input  ${
                  validating && formData.description !== ''
                    ? ''
                    : validating && formData.description === ''
                    ? 'is-invalid'
                    : ''
                } ${formData.description ? 'highlighted-border' : ''}`}
                id='description'
                placeholder='Describe the project'
                autoComplete='new-password'
                value={formData.description}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    description: e.target.value,
                  });
                  setFormValidations({
                    ...formValidations,
                    description: e.target.value !== '',
                  });
                }}
              />
              {validating && formData.description === '' && (
                <div className='error_text'>
                  {'Please provide a valid description.'}
                </div>
              )}
            </div>
            <div className='mb-3'>
              <label htmlFor='owner' className=' globalInputLabel'>
                Owner
              </label>
              <span className='text-danger'>*</span>
              <SelectOwnerDropdown
                selectedUserName={formData?.owner}
                className={`form-control p-0 ${
                  validating &&
                  (formData.owner === null || formData.owner === undefined)
                    ? ''
                    : ''
                }`}
                setSelectedUserName={(val: any) => {
                  setFormData({
                    ...formData,
                    owner: val,
                  });
                  setFormValidations({
                    ...formValidations,
                    owner: !!val,
                  });
                }}
              />
              {validating && !formData.owner && (
                <div className='error_text'>
                  {'Please provide a valid owner.'}
                </div>
              )}
            </div>
            <div className='d-flex justify-content-between gap-2 align-items-center'>
              <div>
                <label className='globalInputLabel' htmlFor='start_date'>
                  Start Date <span className='text-danger'>*</span>
                </label>
                <DatePicker
                  id={'start_date'}
                  selected={
                    formData?.start_date ? new Date(formData?.start_date) : null
                  }
                  onChange={(date: any) => {
                    const utcDate = new Date(
                      Date.UTC(
                        date.getFullYear(),
                        date.getMonth(),
                        date.getDate(),
                        date.getHours(),
                        date.getMinutes(),
                        date.getSeconds()
                      )
                    );
                    setFormData({
                      ...formData,
                      start_date: utcDate.toISOString(),
                    });
                    setFormValidations({
                      ...formValidations,
                      start_date: !!utcDate,
                    });
                  }}
                  className={`form-control ubbe-input ${
                    validating && formData.start_date !== ''
                      ? ''
                      : validating && formData.start_date === ''
                      ? 'is-invalid'
                      : ''
                  } ${formData.start_date ? 'highlighted-border' : ''}`}
                  placeholderText={'Start Date'}
                  dateFormat='yyyy-MM-dd'
                  autoComplete='off'
                  showIcon={true}
                  calendarIconClassname='calendarIcon'
                />

                {validating && !formData.start_date && (
                  <div className='error_text'>
                    {'Please provide a valid start date.'}
                  </div>
                )}
              </div>
              <div>
                <label className='globalInputLabel' htmlFor='end_date'>
                  End Date <span className='text-danger'>*</span>
                </label>
                <DatePicker
                  id={'end_date'}
                  selected={
                    formData?.end_date ? new Date(formData?.end_date) : null
                  }
                  onChange={(date: any) => {
                    const utcDate = new Date(
                      Date.UTC(
                        date.getFullYear(),
                        date.getMonth(),
                        date.getDate(),
                        date.getHours(),
                        date.getMinutes(),
                        date.getSeconds()
                      )
                    );
                    setFormData({
                      ...formData,
                      end_date: utcDate.toISOString(),
                    });
                    setFormValidations({
                      ...formValidations,
                      end_date: !!utcDate,
                    });
                  }}
                  className={`form-control ubbe-input ${
                    validating && formData.end_date !== ''
                      ? ''
                      : validating && formData.end_date === ''
                      ? 'is-invalid'
                      : ''
                  } ${formData.end_date ? 'highlighted-border' : ''}`}
                  placeholderText={'End Date'}
                  dateFormat='yyyy-MM-dd'
                  autoComplete='off'
                  showIcon={true}
                  calendarIconClassname='calendarIcon'
                />
                {validating && !formData.end_date && (
                  <div className='error_text'>
                    {'Please provide a valid end date.'}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='row mt-3 mb-2'>
            <div className='col-sm-12'>
              <p
                className='btn ubbe-blue-bg p-2 px-4 w-100 rounded-3 text-light d-flex m-auto justify-content-center align-items-center mb-2'
                style={{ maxWidth: 'max-content', height: '48px' }}
                onClick={() => {
                  handleAction();
                }}
              >
                Save
              </p>
              <u
                className='m-auto d-flex justify-content-center labelText'
                style={{ cursor: 'pointer' }}
                aria-label='Close'
                onClick={() => onClose()}
              >
                Cancel
              </u>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProjectModal;
